export const formatAmount = (amount, user) => {
    if (!amount && amount !== 0) return user ? '0' : '$0';

   

    const toFixedIfGreater = (value, decimals) => {
        const parts = String(value).split('.');
        if (parts.length > 1 && parts[1].length > decimals) {
            return value.toFixed(decimals);
        }
        return String(value);
    };
    if (user) {
        // For user counts, don't use dollar sign
        // return amount.toLocaleString();
        if (amount >= 1000000) {
            return `${toFixedIfGreater(amount / 1000000, 1)}M`;
        }
        else if (amount >= 1000) {
            return `${toFixedIfGreater(amount / 1000, 2)}K`;
        }
        return `${toFixedIfGreater(amount, 4)}`;
    }
    if (amount >= 1000000) {
        return `$${toFixedIfGreater(amount / 1000000, 1)}M`;
    }
    else if (amount >= 1000) {
        return `$${toFixedIfGreater(amount / 1000, 2)}K`;
    }
    return `$${toFixedIfGreater(amount, 4)}`;
};


// export const formatAmount = (amount, user) => {
//     if (!amount && amount !== 0) return user ? '0' : '$0';

//     if (user) {
//         // For user counts, don't use dollar sign
//         return amount.toLocaleString();
//     }

//     if (amount >= 1000000) {
//         return `$${(amount / 1000000).toFixed(1)}M`;
//     }
//     else if (amount >= 1000) {
//         return `$${(amount / 1000).toFixed(2)}K`
//     }
//     return `$${(amount).toFixed(4)}`;
// };